import React from 'react';
import { ApiStatus } from '../components';

const ApisPage = ({ apiStatus, statusLoading, checkApiStatus }) => {
  return (
    <div className="space-y-6">
      {/* Header da Página */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Status das APIs</h1>
            <p className="text-gray-600">
              Monitore o status e performance de todas as APIs do sistema
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={checkApiStatus}
              disabled={statusLoading}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {statusLoading ? 'Verificando...' : 'Verificar Status'}
            </button>
          </div>
        </div>
      </div>
      
      {/* Conteúdo da Página */}
      <ApiStatus 
        apiStatus={apiStatus}
        statusLoading={statusLoading}
        checkApiStatus={checkApiStatus}
      />
    </div>
  );
};

export default ApisPage;
